(function () {
  'use strict';

  function initLocator(root) {
    var searchInput = root.querySelector('[data-stl-search]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-stl-item]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-stl-detail]'));
    var list = root.querySelector('[data-stl-list]');

    function selectIndex(index) {
      items.forEach(function (item) {
        item.classList.toggle('is-active', item.dataset.index === String(index));
      });
      details.forEach(function (detail) {
        detail.classList.toggle('is-active', detail.dataset.index === String(index));
      });
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        selectIndex(item.dataset.index);
        if (window.innerWidth < 900) {
          var activeDetail = root.querySelector('.stl-detail.is-active');
          if (activeDetail) {
            activeDetail.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

    if (searchInput) {
      var noResultsEl = null;

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        var visibleCount = 0;

        items.forEach(function (item) {
          var haystack = item.dataset.searchText || '';
          var matches = haystack.indexOf(query) !== -1;
          item.classList.toggle('stl-hidden', !matches);
          if (matches) visibleCount += 1;
        });

        if (visibleCount === 0) {
          if (!noResultsEl) {
            noResultsEl = document.createElement('li');
            noResultsEl.className = 'stl-no-results';
            noResultsEl.textContent = 'No encontramos sucursales con ese criterio.';
            list.appendChild(noResultsEl);
          }
        } else if (noResultsEl) {
          noResultsEl.remove();
          noResultsEl = null;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-stl-root]').forEach(function (root) {
      if (root.dataset.stlInitialized) return;
      root.dataset.stlInitialized = 'true';
      initLocator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-stl-root]');
    if (root) {
      root.dataset.stlInitialized = '';
      initLocator(root);
    }
  });
})();
